import {Button, message, Modal} from "antd"
import {Component} from "react"
import {delete_} from "../../helper/request";


class AuditLogDeleteModal extends Component {
    constructor(props) {
        super(props)
    }

    handleDelete = () => {
        delete_("/api/delete_all_audit_logs/").then(response => {
            message.success("Audit Logs Deleted Successfully", 5)
            this.props.closeModal()
            this.props.refreshDump()
        }).catch(error => {
                message.error("There is some error", 5)
                this.props.closeModal()
            }
        )
    }

    render() {
        return (
            <Modal
                visible={this.props.showModal}
                onCancel={this.props.closeModal}
                title="Delete Audit Logs"
                footer={[
                    <Button key="back" ghost type="primary" onClick={() => this.props.closeModal()}>
                        Cancel
                    </Button>,
                    <Button key="submit" ghost type="danger" onClick={() => this.handleDelete()}>
                        Delete Audit Logs
                    </Button>,
                ]}
            >
                <div>This will remove all the
                    <ul>
                        <li>database audit logs</li>
                        <li>user activity logs</li>
                        <li> request logs</li>
                    </ul>

                    You will never be able to recover them.
                </div>
                <div>Are you sure?</div>

            </Modal>
        )
    }
}

export default AuditLogDeleteModal;